// UT-11652. `query=<id>` matches nothing on /v2/search/players: the term clause on `id` is behind
// an `allowSearchById` flag that route never sets. `filter=id:<n>` does work — measured on prod
// 2026-09-11, total 0 vs total 1. That is why an id is routed differently instead of being typed
// straight through.

const PLAYER_ID_PATTERN = /^\d+$/;

/**
 * Only a string of digits counts, so a partial name, a name starting with a digit, or a
 * hyphenated, decimal or negative number all stay name queries. The id is passed through exactly
 * as typed, leading zeros included — the API owns what matches.
 *
 * @param {string} query - the raw text the user typed
 * @returns {{isPlayerIdLookup: boolean, playerId?: string}}
 */
export const resolvePlayerSearchQuery = (query) => {
    const trimmed = typeof query === 'string' ? query.trim() : '';

    if (!PLAYER_ID_PATTERN.test(trimmed)) {
        return { isPlayerIdLookup: false };
    }

    return { isPlayerIdLookup: true, playerId: trimmed };
};
